import type { SelectValuesFragmentFragment } from '@packages/gql/generated/shopping/graphql';
import { type DialogProps, Dialog } from '@packages/shared/src/components/Dialog/Dialog';
import { useIntl } from 'react-intl';
import type { SetSelectedVariation } from '../../types/types';
import { variationSelectionDialogMessages } from './messages';
import { VariationRow } from './VariationRow/VariationRow';

export type VariationSelectionDialogProps = {
  dimensionData: SelectValuesFragmentFragment;
  open: boolean;
  handleClose: NonNullable<DialogProps['handleClose']>;
  onChange: SetSelectedVariation;
};

/**
 * VariationSelectionDialog component
 *
 * dialog to select a different variation
 *
 * */
export const VariationSelectionDialog = ({
  dimensionData,
  open,
  handleClose,
  onChange,
}: VariationSelectionDialogProps) => {
  const { formatMessage } = useIntl();
  const hasImage = dimensionData.values.some(
    (value) => value.image !== null || value.rgb !== null || value.variationMainImage !== null,
  );

  const clickHandler = (sku: SelectValuesFragmentFragment['values'][number]['sku']) => {
    onChange(sku);
    handleClose();
  };

  return (
    <Dialog
      title={formatMessage(variationSelectionDialogMessages.headline, {
        dimension: dimensionData.displayName,
      })}
      dialogContent={
        <ul className="list-none">
          {dimensionData.values.map((value) => (
            <li>
              <VariationRow
                value={value}
                hasImage={hasImage}
                clickHandler={clickHandler}
                key={value.sku}
              />
            </li>
          ))}
        </ul>
      }
      dialogContentSxProps={{ bgcolor: 'common.white' }}
      open={open}
      handleClose={handleClose}
    />
  );
};
